const PROVIDER_USAGE_LIMIT_KEY = "provider";
const PROVIDER_USAGE_LIMIT_LABEL = "Usage limits";
export function createUnsupportedProviderUsageLimits(observedAt, provider) {
    return [
        createProviderUsageLimitWithoutFacts("unsupported", observedAt, provider),
    ];
}
export function createUnavailableProviderUsageLimits(observedAt, provider) {
    return [
        createProviderUsageLimitWithoutFacts("unavailable", observedAt, provider),
    ];
}
function createProviderUsageLimitWithoutFacts(status, observedAt, provider) {
    return {
        key: provider
            ? `${provider.id}:${PROVIDER_USAGE_LIMIT_KEY}`
            : PROVIDER_USAGE_LIMIT_KEY,
        label: PROVIDER_USAGE_LIMIT_LABEL,
        observedAt,
        ...(provider ? { provider } : {}),
        resetsAt: null,
        status,
        usedPercent: null,
    };
}
